var React = require('react');

function Codeforces (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.5 7.5A1.5 1.5 0 0 1 6 9v10.5A1.5 1.5 0 0 1 4.5 21h-3C.673 21 0 20.328 0 19.5V9c0-.828.673-1.5 1.5-1.5h3zm9-4.5A1.5 1.5 0 0 1 15 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-3c-.827 0-1.5-.672-1.5-1.5v-15c0-.828.673-1.5 1.5-1.5h3zm9 7.5A1.5 1.5 0 0 1 24 12v7.5a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5V12a1.5 1.5 0 0 1 1.5-1.5h3z","key":0}),React.createElement("rect",{"x":"0","y":"0","width":"24","height":"24","fill":"rgba(0, 0, 0, 0)","key":1})]);
}

Codeforces.defaultProps = {"aria-hidden":"true","focusable":"false","width":"1em","height":"1em","style":{"msTransform":"rotate(360deg)","WebkitTransform":"rotate(360deg)","transform":"rotate(360deg)"},"preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 24 24"};

module.exports = Codeforces;

Codeforces.default = Codeforces;
